export default {
  firstBoundaryType: "lga",
  firstIndicator: "urban_liveability_index",
  firstDomain: "Liveability",
  firstYear: "2024",
};
